/**
 * La longitud mínima de una contraseña NUEVA, comprobada también aquí
 * (auditoría del onboarding del 2026-10-29, hallazgo 12): antes sólo la
 * comprobaba el servidor, después de «Creando…».
 *
 * Manda el servidor (`OD-0027` D-01, `MIN_PASSWORD_LENGTH` en
 * `apps/api/src/modules/auth/domain/password-policy.ts`): si cambia allí, su
 * mensaje de error sigue llegando. `web-shell.mjs` comprueba que los dos
 * números coinciden. Cuenta CARACTERES, no bytes, como la API.
 */
export const MINIMO_CONTRASENA = 12;

export function contrasenaCorta(password: string): boolean {
  return [...password].length < MINIMO_CONTRASENA;
}
